import Api from './apiHandler'
const BASE = 'users'

const UserApi = {
  getAllUser: () => Api.get(`${BASE}`),
  getDetailUserNoAuth: id => Api.get(`${BASE}/${id}`),
  getDetailUser: () => Api.get(`${BASE}/profile`),
  updateStatusOnline: data => Api.patch(`${BASE}/isOnline`, data),
  updateLocation: data => Api.patch(`${BASE}/location`, data),
  updateProfile: (id, data) => Api.patch(`${BASE}/${id}`, data),
}

export default UserApi